// extracted by mini-css-extract-plugin
export var actionButton = "_a8-0";
export var attachmentLine = "_a8-1";
export var fileInput = "_a8-2";
export var fileUploadWrapper = "_a8-4";
export var footer = "_a8-3";
export var modalContent = "_a8-5";
export var paperclip = "_a8-6";
export var quillEditor = "_a8-7";